import { render, staticRenderFns } from "./footer-navs.vue?vue&type=template&id=059003a0&scoped=true&"
import script from "./footer-navs.vue?vue&type=script&lang=js&"
export * from "./footer-navs.vue?vue&type=script&lang=js&"
import style0 from "./footer-navs.vue?vue&type=style&index=0&id=059003a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059003a0",
  null
  
)

export default component.exports